import type { ReactNode } from 'react';
import { PostHogProvider } from 'posthog-js/react';

interface PostHogWrapperProps {
  children: ReactNode;
}

const posthogEnabled = import.meta.env.VITE_POSTHOG_ENABLED === 'true';
const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;

if (posthogEnabled && !posthogKey) {
  console.warn('PostHog is enabled but VITE_POSTHOG_KEY is not set');
}

export function PostHogWrapper({ children }: PostHogWrapperProps) {
  if (!posthogEnabled || !posthogKey) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider
      apiKey={posthogKey}
      options={{
        api_host: import.meta.env.VITE_POSTHOG_HOST,
        ui_host: import.meta.env.VITE_POSTHOG_UI_HOST,
        defaults: '2026-01-30',
        capture_exceptions: true,
        debug: import.meta.env.DEV,
      }}
    >
      {children}
    </PostHogProvider>
  );
}
